/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';

import Bookings from 'assets/images/reports/Bookings.svg';
import Clients from 'assets/images/reports/Clients.svg';
import Commissions from 'assets/images/reports/Commissions.svg';
import Discounts from 'assets/images/reports/Discounts.svg';
import Downloadable from 'assets/images/reports/Downloadable.svg';
import FutureRevenue from 'assets/images/reports/FutureRevenue.svg';
import Hours from 'assets/images/reports/Hours.svg';
import MonthlyDashboard from 'assets/images/reports/MonthlyDashboard.svg';
import PaymentTypes from 'assets/images/reports/PaymentTypes.svg';
import Retail from 'assets/images/reports/Retail.svg';
import Revenue from 'assets/images/reports/Revenue.svg';
import StaffKPIs from 'assets/images/reports/StaffKPIs.svg';
import WeeklyDashboard from 'assets/images/reports/WeeklyDashboard.svg';
import CurrencySign from 'components/price/CurrencySign.component';
import LINK from 'constants/link.const';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import linkTo from 'utils/links/linkTo.util';

import { setCurrentTable } from 'reports/actions';

const TooltipDiscount = () => {
  const { t } = useTranslation();
  return (
    <>
      {t('businessReports.bucketReports.discounts.tooltip.part1')}
      {S.space}
      <CurrencySign />
      {S.space}
      {t('businessReports.bucketReports.discounts.tooltip.part2')}
    </>
  );
};

const TooltipPayment = () => {
  const { t } = useTranslation();
  return (
    <>
      {t('businessReports.bucketReports.paymentTypes.tooltip.part1')}
      {S.space}
      <CurrencySign />
      {S.space}
      {t('businessReports.bucketReports.paymentTypes.tooltip.part2')}
    </>
  );
};

const determineReportCards = (t) => [
  {
    id: '1',
    name: t('businessReports.bucketReports.weeklyDashboard.name'),
    description: t('businessReports.bucketReports.weeklyDashboard.description'),
    img: WeeklyDashboard,
    tooltip: t('businessReports.bucketReports.weeklyDashboard.tooltip'),
    colorBtn: '#821bb8',
    reportToGo: 'dashboard',
  },
  {
    id: '2',
    name: t('businessReports.bucketReports.staffKPIs.name'),
    description: t('businessReports.bucketReports.staffKPIs.description'),
    img: StaffKPIs,
    tooltip: t('businessReports.bucketReports.staffKPIs.tooltip'),
    colorBtn: '#821bb8',
    reportToGo: 'staffkpi',
  },
  {
    id: '3',
    name: t('businessReports.bucketReports.monthlyDashboard.name'),
    description: t('businessReports.bucketReports.monthlyDashboard.description'),
    img: MonthlyDashboard,
    tooltip: t('businessReports.bucketReports.monthlyDashboard.tooltip'),
    colorBtn: '#821bb8',
    reportToGo: 'monthly-dashboard',
  },
  {
    id: '4',
    name: t('businessReports.bucketReports.revenue.name'),
    description: t('businessReports.bucketReports.revenue.description'),
    img: Revenue,
    tooltip: t('businessReports.bucketReports.revenue.tooltip'),
    colorBtn: '#5e72d1',
    reportToGo: 'revenue',
  },
  {
    id: '5',
    name: t('businessReports.bucketReports.futureRevenue.name'),
    description: t('businessReports.bucketReports.futureRevenue.description'),
    img: FutureRevenue,
    tooltip: t('businessReports.bucketReports.futureRevenue.tooltip'),
    colorBtn: '#5e72d1',
    reportToGo: 'future-revenue',
  },
  {
    id: '6',
    name: t('businessReports.bucketReports.discounts.name'),
    description: t('businessReports.bucketReports.discounts.description'),
    img: Discounts,
    tooltip: <TooltipDiscount />,
    colorBtn: '#5e72d1',
    reportToGo: 'revenue',
  },
  {
    id: '7',
    name: t('businessReports.bucketReports.retail.name'),
    description: t('businessReports.bucketReports.retail.description'),
    img: Retail,
    tooltip: t('businessReports.bucketReports.retail.tooltip'),
    colorBtn: '#e65e9e', // pink
    reportToGo: 'retail',
  },
  {
    id: '8',
    name: t('businessReports.bucketReports.staffCommissions.name'),
    description: t('businessReports.bucketReports.staffCommissions.description'),
    img: Commissions,
    tooltip: t('businessReports.bucketReports.staffCommissions.tooltip'),
    colorBtn: '#e65e9e', // pink
    reportToGo: 'commissions',
  },
  {
    id: '9',
    name: t('businessReports.bucketReports.paymentTypes.name'),
    description: t('businessReports.bucketReports.paymentTypes.description'),
    img: PaymentTypes,
    tooltip: <TooltipPayment />,
    colorBtn: '#e65e9e',
    reportToGo: 'payments',
  },
  {
    id: '10',
    name: t('businessReports.bucketReports.hours.name'),
    description: t('businessReports.bucketReports.hours.description'),
    img: Hours,
    tooltip: t('businessReports.bucketReports.hours.tooltip'),
    colorBtn: '#3da49d',
    reportToGo: 'hours',
  },
  {
    id: '11',
    name: t('businessReports.bucketReports.clients.name'),
    description: t('businessReports.bucketReports.clients.description'),
    img: Clients,
    tooltip: t('businessReports.bucketReports.clients.tooltip'),
    colorBtn: '#3da49d', // green
    reportToGo: 'staffkpi',
  },
  {
    id: '12',
    name: t('businessReports.bucketReports.bookings.name'),
    description: t('businessReports.bucketReports.bookings.description'),
    img: Bookings,
    tooltip: t('businessReports.bucketReports.bookings.tooltip'),
    colorBtn: '#3da49d',
    reportToGo: 'bookings',
  },
  {
    id: '13',
    name: t('businessReports.bucketReports.downloadable.name'),
    description: t('businessReports.bucketReports.downloadable.description'),
    img: Downloadable,
    tooltip: t('businessReports.bucketReports.downloadable.tooltip'),
    colorBtn: '#e2c67a', // ocher
    reportToGo: 'downloadable',
  },
];

const BucketsReportsLayout = ({ setCurrentTable }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const salonId = useCurrentSalonId();
  const summaryKpiLink = linkTo({ pattern: LINK.slnStaffReportsKpi, params: { salonId }, fault: '#' });

  const gotoReport = (url, tableName) => {
    const toPath = `/salon/${salonId}/reports/${url}`;
    history.push(toPath);
    setCurrentTable(tableName);
  };

  const REPORTS = determineReportCards(t);

  return (
    <div className="bucket-layout">
      <h2>{t('businessReports.bucketReports.pageTitle')}</h2>
      <div className="buckets-container">
        {REPORTS.map((report) => (
          <div className="list-grid-item" key={report.id}>
            <div className="bucket-text">
              <div className="primary-text">{report.name}</div>
              <div className="supporting-text">{report.description}</div>
            </div>
            <div className="rectangle">
              <img className="img_test" src={report.img} alt={report.name} />
              <div className="img-shadow" />
            </div>
            <div className="client-info">
              <div className="info-icon">
                <span className="tooltip">
                  <div className="tooltip-centered">{report.tooltip}</div>
                </span>
              </div>
              <span className="client-info-span">{t('businessReports.bucketReports.howToUse')}</span>
            </div>
            <div className="d-block">
              {report.id === '2' || report.id === '11' ? (
                <NavLink to={summaryKpiLink} className="btn rainbow" style={{ backgroundColor: report.colorBtn }}>
                  {t('businessReports.bucketReports.goToReportButton')}
                </NavLink>
              ) : (
                <button type="button" className="btn rainbow" style={{ backgroundColor: report.colorBtn }} onClick={() => gotoReport(report.reportToGo, report.name)}>
                  {t('businessReports.bucketReports.goToReportButton')}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setCurrentTable: (table) => dispatch(setCurrentTable(table)),
});

export default connect(null, mapDispatchToProps)(BucketsReportsLayout);
